import React from 'react'
import { Button, Stack, SimpleModal } from '@/components/lib'

export default function UnsavedModal ({ header, body, blocker }) {
  return (
    <SimpleModal
      isOpen={blocker?.state === 'blocked'}
      onClose={() => blocker?.state === 'blocked' && blocker.reset()}
      header={header || 'Really leave this page?'}
      body={body || 'You may have unsaved changes that will be lost.'}
      footer={
        <Stack direction='row' spacing={4}>
          <Button onClick={() => blocker?.state === 'blocked' && blocker.proceed()}>
            Leave without saving
          </Button>
          <Button colorPalette='primary' onClick={() => blocker?.state === 'blocked' && blocker.reset()}>
            Stay on page
          </Button>
        </Stack>
      }
    />
  )
}
